import React from 'react';
import FormikRadioButtons from 'src/components/formik-radio-buttons';

const AssociatesDegreeInput = () => (
  <FormikRadioButtons
    name="communityCollegeInfo.plansToCompleteAssociateDegree"
    options={[
      {value: 'true', label: 'Yes'},
      {value: 'false', label: 'No / not sure / does not apply to me'},
    ]}
    legendText={
      <>
        <p>Do you plan to complete an Associate degree before transferring?</p>
        <span>
          Some 4-year colleges award scholarships for credit hour progress to students who plan to
          complete an Associate degree before transferring
        </span>
      </>
    }
  />
);

export default AssociatesDegreeInput;
